<template>
    <ValidationObserver
        ref="connectVenueToSheetDialog"
        v-slot="{ passes }"
    >
        <BaseDialog
            :showDialog="showDialog"
            :headline="headline"
            :close="close"
            maxDialogWidth="800"
            maxCardHeight="800"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid v-if="!showVenueFields">
                    <v-row>
                        <v-col cols="10">
                            <SearchFilter 
                                :context="context" 
                                @keydown.enter="searchForListItems"
                                :alvqa="alvqa + '-textfield-search'"
                            />
                        </v-col>
                        <v-col align-self="end" class="text-left">
                            <BaseIcon 
                                @click="searchForListItems" 
                                icon="fa-search" 
                                tooltipText="lang_GENERIC_CAPTION_SEARCH"
                                :alvqa="alvqa + '-button-search'"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="showSearchResult" class="pb-3">
                        <v-col v-if="items.length !== 0">
                            <BaseHeaderStats 
                                :context="context" 
                                typeStats="DIALOG"
                                :alvqa="alvqa"
                                useContextForTotal="ConnectVenueToSheetDialog"
                            />
                        </v-col>
                        <v-col 
                            v-else
                            :alvqa="alvqa + '-text-none-found'"
                        >
                        0 {{ $t('lang_GENERAL_CAPTION_FOUND') }}
                        </v-col>
                    </v-row>
                    <v-divider v-if="items.length > 0"></v-divider>
                    <v-list two-line>
                        <v-list-item-group
                            v-model="selected"
                            :multiple="false"
                        >
                            <v-list-item
                                v-for="item in items"
                                :key="item.alvId"
                                :value="item"
                                :alvqa="alvqa + '-result-list-row-' + item.alvId"
                                @click="selectItem(item)"
                            >
                                <v-list-item-content>
                                    <v-list-item-title :alvqa="alvqa + '-result-list-row-' + item.alvId + '-name'">
                                        {{ item.name }} ({{ item.alvId }})
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-result-list-row-' + item.alvId + '-subtitle'">
                                        {{ item.addressRow1 }}, {{ item.zip }} {{ item.city }}, {{ $alvPlugin.getTranslatedCountryName(item.country)  }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-container>
                <v-container fluid v-else-if="showVenueFields">
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="venueContext"
                                field="VenueName"
                                :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE')" 
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :disabled="!createNew"
                                :alvqa="alvqa + '-textfield-venue-name'"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="venueContext"
                                field="AddressRow1"
                                :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :alvqa="alvqa + '-textfield-address-row-one'"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="venueContext"
                                field="City"
                                :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :alvqa="alvqa + '-textfield-city'"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="venueContext"
                                field="Zip"
                                :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :alvqa="alvqa + '-textfield-zip'"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageDropdown 
                                :context="venueContext"
                                field="Country"
                                :items="countries" 
                                :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"  
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-country'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row v-if="!showVenueFields">
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                :disabled="selectedVenue.length !== 0" 
                                @click="editVenue(true)"
                                label="lang_PUBLISHING_SHEETS_CAPTION_CREATE_VENUE"
                                :alvqa="alvqa +  '-button-create'"
                            />
                        </v-col>
                        <v-col class="text-right">
                            <BaseButton 
                                :disabled="selectedVenue.length === 0" 
                                @click="editVenue()"
                                label="lang_PUBLISHING_SHEETS_CAPTION_SELECT_VENUE"
                                :alvqa="alvqa +  '-button-select'"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                @click="backToSearch()"
                                label="lang_GENERAL_BUTTON_CANCEL"
                                :alvqa="alvqa +  '-button-back'"
                            />
                        </v-col>
                        <v-col class="text-right">
                            <BaseButton 
                                @click="passes(connectAndSaveVenue)"
                                label="lang_GENERIC_CAPTION_SAVE_AND_CONNECT"
                                :alvqa="alvqa +  '-button-save-connect'"
                            />
                        </v-col>
                    </v-row>    
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
// import SearchDialog from '@/components/_dialogs/SearchDialog'
import BaseDialog from '@/components/_base/BaseDialog'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'

import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "ConnectVenueToSheetDialog",
    components: {
        // SearchDialog,
        BaseDialog,
        SearchFilter,
        BaseIcon,
        BaseHeaderStats,
        BaseButton,

        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            // context: "Sheets",
            alvqa: "publishing-sheets-edit-form",
            showSearchResult: false,
            items: [],
            selected: [],
            context: 'VenueForSheets',
            showVenueFields: false,
            createNew: false,
            headline: "lang_PUBLISHING_SHEETS_CAPTION_CONNECT_VENUE",
            venueContext: "AzLive"
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowConnectVenueToSheetDialog },
            set(show) { this.$store.commit("setShowConnectVenueToSheetDialog", show) }
        },
        selectedVenue: {
            get() { return this.$store.getters.getSelectedVenueForSheets },
            set(venue) { this.$store.commit("setSelectedVenueForSheets", venue) }
        },
        countries() { return this.$alvPlugin.getListOfTranslatedCountries() },
    },
    methods: {
        close() {
            this.showDialog = false
            this.selectedVenue = []
            this.selected = []
            this.showSearchResult = false
            this.items = []
            this.showVenueFields = false
            this.createNew = false
            this.headline = "lang_PUBLISHING_SHEETS_CAPTION_CONNECT_VENUE"
            this.$store.commit('setVenueForSheetsSearch', null)
            this.$store.commit('setTotalListedConnectVenueToSheetDialog', 0)
            this.$store.commit('setTotalRecordsConnectVenueToSheetDialog', 0)
        },
        async searchForListItems() {
            this.$store.commit('setIsLoading', true)
            let search = this.$store.getters.getVenueForSheetsSearch
            if(search) {
                this.selectedVenue = []
                this.selected = []
                this.showSearchResult = true
                this.items = await this.$store.dispatch('searchVenueForSheets')
            }

            if(!search) this.items = []
            this.$store.commit('setIsLoading', false)
        },
        editVenue(newVenue = false) {
            this.showVenueFields = true
            if(newVenue) {
                this.headline = "lang_PUBLISHING_SHEETS_CAPTION_CREATE_VENUE"
                this.createNew = true
                this.$store.commit('setAzLiveDetails', this.$store.getters.getDefaultAzLive)
            } else {
                this.headline = "lang_PUBLISHING_SHEETS_CAPTION_EDIT_VENUE"
                this.$store.commit('setAzLiveDetails', this.selectedVenue[0])
            }
        },
        selectItem(item) {
            if(this.selectedVenue.length === 0) {
                this.selectedVenue.push(item)
            } else {
                if(this.selectedVenue[0]["id"] === item.id) this.selectedVenue = []
                else {
                    this.selectedVenue = []
                    this.selectedVenue.push(item)
                }
            }
        },
        connectAndSaveVenue() {
            this.$store.dispatch("saveAzLiveForm", false)
            let venue = this.$store.getters.getAzLiveDetails
            this.$store.commit('setSheetDetailsEventVenue', venue)
            this.$store.commit('setSheetDetailsEventVenueId', venue.id)
            this.close()
            // if(this.$store.getters.getSheetDetailsEventOrganizer === null) {
            //     this.$store.commit('setSheetEventOrganizerOptions', venue)
            //     this.$store.commit('setSheetDetailsEventOrganizer', venue)
            //     this.$store.commit('setSheetDetailsEventOrganizerId', venue.id)
            // }
        },
        backToSearch() {
            this.showVenueFields = false
        }
    },
    mounted() {
        this.$store.commit('setCountries')
    }
}
</script>